import { useAtomValue } from 'jotai'
import { useTranslation } from 'react-i18next'
import { localeAtom } from 'src/stores/locale'
import { formatPrice, useCurrency } from 'src/utils/currency'
import type { ExtraPackage } from '../api/types'
import { MonthlyPackCard } from '../components/MonthlyPackCard'
import { PackSectionHeader } from '../components/PackSectionHeader'
import { sortBoostsPriority } from '../domain/sortBoostsPriority'
import { formatLocalizedNumber } from '../utils/formatLocalizedNumber'

interface MonthlyPackSectionProps {
  packs: ExtraPackage[]
  showingSuccessId: string | null
  currentTier: number
  selectedTier: number
  onPurchase: (pack: ExtraPackage) => void
  onRequireUpgradeClick?: () => void
}

export function MonthlyPackSection(props: MonthlyPackSectionProps) {
  const { t } = useTranslation(['membership'])
  const [currency] = useCurrency()
  const locale = useAtomValue(localeAtom)
  if (props.packs.length === 0) return null

  return (
    <>
      <PackSectionHeader>
        {t('membership:extra-pack.groups.special.label')}
      </PackSectionHeader>
      {props.packs.map(pack => {
        const tierValue = pack.values[props.selectedTier]
        const baseValue = pack.values[0].value
        const purchasable = props.currentTier === props.selectedTier
        return (
          <MonthlyPackCard
            key={pack.id}
            baseCreditsLabel={formatLocalizedNumber(baseValue, locale)}
            baseCredits={baseValue}
            boostedCredits={tierValue.creditsAfterBoosts}
            isBoosted={baseValue !== tierValue.creditsAfterBoosts}
            boosts={sortBoostsPriority(tierValue.boosts ?? []) ?? []}
            priceLabel={formatPrice(currency, pack.prices[currency])}
            locale={locale}
            animateCredits={props.currentTier === 0}
            disabled={!purchasable && Boolean(props.onRequireUpgradeClick)}
            showSuccess={props.showingSuccessId === pack.id}
            onPurchase={
              purchasable
                ? () => props.onPurchase(pack)
                : props.onRequireUpgradeClick
            }
          />
        )
      })}
    </>
  )
}
